import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpecialEvents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#special-events_svg__a)">
      <path
        fill="#263E6A"
        d="M19.563 3.298a4.52 4.52 0 0 0-6.383.043 4.5 4.5 0 0 0-1.292 2.901.33.33 0 0 0 .092.252l4.228 4.427c.063.067.15.104.242.104h.005a4.5 4.5 0 0 0 3.151-1.344 4.52 4.52 0 0 0-.043-6.383M19.13 9.21a3.82 3.82 0 0 1-2.54 1.14l-4.02-4.211a3.84 3.84 0 0 1 1.089-2.327 3.847 3.847 0 0 1 5.434-.036 3.847 3.847 0 0 1 .037 5.434m-5.501 6.592c-.6 0-1.15.226-1.64.673l-.014.013-4.219 4.3a1.8 1.8 0 1 1-2.557-2.53l1.886-1.91.4.399a.335.335 0 0 0 .436.032l7.408-5.504a.336.336 0 0 0 .04-.504L11.95 7.27a.335.335 0 0 0-.507.032l-5.604 7.394a.335.335 0 0 0 .03.44l.74.739-1.886 1.911A2.45 2.45 0 0 0 4 19.531 2.47 2.47 0 0 0 6.469 22c.67 0 1.298-.264 1.766-.743l4.212-4.293c.36-.326.757-.491 1.18-.491a1.665 1.665 0 0 1 1.169 2.848l-1.366 1.35a.335.335 0 0 0 .47.479l1.309-1.287.014-.015.06-.066a2.32 2.32 0 0 0 .679-1.646 2.337 2.337 0 0 0-2.334-2.334m-1.886-7.786 2.879 2.95-6.868 5.102-1.203-1.201zM8.18 7.603a.45.45 0 0 1-.293-.118l-1.001-.883-.01-.002-1.295.324A.42.42 0 0 1 5.15 6.8a.42.42 0 0 1-.053-.447l.53-1.226v-.01l-.71-1.13a.42.42 0 0 1-.014-.45.42.42 0 0 1 .408-.189l1.33.126.008-.004.858-1.024a.42.42 0 0 1 .423-.153c.153.037.267.16.305.33l.292 1.304.006.007 1.238.499a.42.42 0 0 1 .277.355.42.42 0 0 1-.22.393l-1.15.68-.004.007-.092 1.333a.42.42 0 0 1-.252.372.4.4 0 0 1-.149.03M6.872 5.929c.161 0 .33.059.447.16l.628.555.058-.836a.69.69 0 0 1 .32-.518l.72-.426-.777-.313a.7.7 0 0 1-.394-.464l-.183-.818-.537.642a.69.69 0 0 1-.564.232l-.833-.08.444.71a.69.69 0 0 1 .046.608l-.333.768.813-.203a.6.6 0 0 1 .145-.017m1.801-.075"
      />
    </g>
    <defs>
      <clipPath id="special-events_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpecialEvents;
